import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface SetClaimGroupReasonCommentCommandArgs {
  claimGroupId: string;
  ownerProductIds: string[];
  reasonComment: string;
}

export const setClaimGroupReasonCommentRequest = ({
  claimGroupId,
  ownerProductIds,
  reasonComment,
}: SetClaimGroupReasonCommentCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/reasonComment`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { ownerProductIds, reasonComment },
  },
});

export const setClaimGroupReasonCommentCommand = async (
  args: SetClaimGroupReasonCommentCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimGroupReasonCommentRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
